
import { openSessionLoginModal } from "../../common/api/hooks/useAxiosPrivate";
import React,{useContext,useEffect,useState} from 'react'
import { captureChartInteraction, useChartsToolOpenState } from '../../analytics/chartsTool';
import { UserSettingsContext } from '../../setup/routes-manager/RequireAuth'
import { useAxiosWithAuth } from '../../common/api/hooks/useAxiosWithAuth';
import { URL } from '../../common/api/urls';
import { useNavigate, useLocation } from 'react-router-dom';
import { TEXT_MSGS } from '../../common/utility/constant';
import { CircularProgress,InputLabel,Switch,Radio,RadioGroup,FormControlLabel,FormLabel } from '@mui/material';
import {Grid, Box,Typography,Select,ListSubheader,TextField,InputAdornment,FormControl,MenuItem,Popover,Divider} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SettingsFooter from './components/settings_footer';
import AppErrorPopup from '../../components/AppErrorPopup';
import { findIndex } from '@amcharts/amcharts5/.internal/core/util/Array';
import { VP_TYPE,VA_TYPE } from '../../common/utility/mp_chart_constants';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTheme} from '@mui/material/styles';
import { BOOKMARK_CATEGORY_AUTOSAVE } from '../../common/utility/constant';
import LoginModal from '../../components/landing/sections/LoginPopupNew';
import ConfirmActionDialog from './components/confirm_dialog';

const Bookmarks = () => {
  const theme=useTheme();
  const from = "/login";
  const navigate = useNavigate(); 
  const [searchText, setSearchText] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog,setOpenDialog]=useState(false);
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  const [cancel,responseData, error, loaded, reset,executeAPI ] = useAxiosWithAuth();
  const [cancelDelete,responseDataDelete, errorDelete, loadedDelete, resetDelete,executeAPIDelete ] = useAxiosWithAuth();
  const [bookmarkState, setBookmarkState]=useState({
    bookmarkData:undefined,
    displayData:undefined,
    isLoaded:false
  });
  const [deletedId,setDeletedId]=useState();
  const [deletedName,setDeletedName]=useState();

  const {bookmarkData,displayData,isLoaded}=bookmarkState;
  useChartsToolOpenState(Boolean(isLoaded));
  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
  const [showLoginPopup,setShowLoginPopup]=useState(false);
  const [loginMsg,setLoginMsg]=useState(TEXT_MSGS.LOGIN_POPUP_MSG);
  
  /**
 * autoclosing of the snackbar msg bar 
 */ 
   const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};
  const { open, msg, severity } = msgState;

  useEffect(() => {
    document.title = "Market Profile Bookmarks";
  }, []);

  //load bookmarks
  useEffect(()=>{
    executeAPI(URL.GET_BOOKMARK_LIST,"GET",{})
  },[])

   //api response handler
   useEffect(()=>{
    if(loaded){
      console.log("Bookmark list ========>",responseData.data);
      if(responseData!=null){
        let data=responseData.data.filter(item => item.category!=BOOKMARK_CATEGORY_AUTOSAVE);
        // let data=responseData.data;
        setBookmarkState((prevState)=>({
          ...prevState,
          bookmarkData:data,
          displayData:data,
          isLoaded:true
        }))
       }else if(error!==null){
        setBookmarkState((prevState)=>({
          ...prevState,
          isLoaded:true
        }))

        console.log("Error data=",error);
        
       
        // setMsgState({open:true,msg:errorAutoSave?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        if(error?.response?.status === 401 || error?.response?.status === 403){
          console.log("status received =",error?.response?.status)
          navigate(from, { replace: true });
        }else{
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        }
      }
      reset();
      
    }

  },[loaded,responseData])

  const deleteBookmark=(id, name)=>{
    setDeletedId(id);
    setDeletedName(name);
    setOpenDialog(true);
  }

  const deleteBookmarkConfirm=()=>{
    // setDeletedId(selectedBookmark.id);
    setOpenDialog(false);
    let data={
      "id":deletedId
    }
    executeAPIDelete(URL.DELETE_BOOKMARK,"DELETE",data)
  }
  
  const cancelBookmarkDelete=()=>{
    setOpenDialog(false);
    setDeletedId(undefined);
    setDeletedName(undefined);
  }

  //delete api response handler
  useEffect(()=>{
    if(loadedDelete){
      console.log("Delete response ========>",responseDataDelete);
      if(responseDataDelete!=null){
        setMsgState({open:true,msg:`${TEXT_MSGS.BOOKMARK_DELETED_SUCCESSFULLY}`,severity:"success"});
        let updatedData= bookmarkData.filter(item => item.id!=deletedId);
        localStorage.setItem("bookmark_list",JSON.stringify(updatedData));
        setBookmarkState((prevState)=>({
          ...prevState,
          bookmarkData:updatedData,
          displayData:updatedData,
          isLoaded:true
        }))
        setDeletedId(undefined);
       
       }else if(errorDelete!==null){
        setBookmarkState((prevState)=>({
          ...prevState,
          isLoaded:true
        }))
        setDeletedId(undefined);

       
        setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
        if(errorDelete?.response?.status === 401 || errorDelete?.response?.status === 403){
          console.log("status received =",errorDelete?.response?.status)
          // navigate(from, { replace: true });
          openSessionLoginModal(errorDelete);
        }else
        setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
      }
      resetDelete();
      
    }

  },[loadedDelete,responseDataDelete])


  const copyURL =(event,id)=>{
    const url=`${process.env.REACT_APP_URL}market-profile?bookmarkID=${id}`
    navigator.clipboard.writeText(url);
    captureChartInteraction('charts_shared', { method: 'copy_url', bookmark_type: 'local' });
    setAnchorEl(event.currentTarget);
  }

  const openBookmark=(event,id)=>{
      const url=`${process.env.REACT_APP_URL}market-profile?bookmarkID=${id}`
      captureChartInteraction('charts_bookmark_opened', { bookmark_type: 'local' });
      window.open( `${url}`, '_blank', 'noreferrer');
    
  }

  return (
   <>

   {isLoaded?
   <Box display="flex" flexDirection="column" sx={{m:4}}>
    <Typography sx={{mt:0,fontSize:20}}>Market Profile Bookmarks</Typography>
    {bookmarkData.length>0?
    <Box sx={{mt:4}}>
      <Box display='flex' sx={{mb:2}}>
           <Typography sx={{mt:0,fontSize:18,width:400}}>Name</Typography>
           <Typography sx={{mt:0,ml:2,fontSize:18,width:240}}>Category</Typography>
           <Typography sx={{mt:0,ml:2,fontSize:18,width:160,paddingTop:"0px"}}>Last Updated</Typography>
           </Box>
       {displayData.map((item,index) => (
        <Box display='flex' sx={{height:70,borderBottom:"1px solid #888",mt:2}}>
          <Box sx={{width:400}}>
           <Typography noWrap sx={{mt:0,fontSize:16,width:300}}>{item.name}</Typography>
           <Box display='flex'>
            <Typography sx={{mt:1,fontSize:12,color:"#eee"}}>Instrument:&nbsp;{item.data.instrument},&nbsp;</Typography>
            <Typography sx={{mt:1,fontSize:12,color:"#eee"}}>Time Frame:&nbsp;{item.data.tf},&nbsp;</Typography>
            <Typography sx={{mt:1,fontSize:12,color:"#eee"}}>TPO:&nbsp;{item.data.tpo}</Typography>
           </Box>
           </Box>
           <Box sx={{width:240,ml:2}}>
           <Typography noWrap sx={{mt:1,fontSize:16,width:240}}>{item.category}</Typography>
           </Box>
           <Box sx={{width:160,ml:2}}>
           <Typography sx={{mt:1,fontSize:14,width:160}}>{item.last_saved}</Typography>
           </Box>
           {openDialog?
              <ConfirmActionDialog open={true} cancelHandler={cancelBookmarkDelete} saveHandler={deleteBookmarkConfirm} 
                  title={TEXT_MSGS.DELETE_BOOKMARK_TITLE} description={TEXT_MSGS.DELETE_BOOKMARK_MSG + " (" + deletedName + ")"}></ConfirmActionDialog>    :
              <></>
            }
           <DeleteIcon onClick={()=>deleteBookmark(item.id, item.name)} sx={{color: "#e24747",cursor:'pointer',ml:4,mt:1}}></DeleteIcon>
           <Tooltip title="Open in new tab">
           <Button onClick={(event)=>openBookmark(event,item.id)} variant='outlined' sx={{ml:2,mr:2,marginTop:"0px",color:"#fff",height:40,width:110}}>Open</Button>
           </Tooltip>
           <Button onClick={(event)=>copyURL(event,item.id)} variant='outlined' sx={{ml:2,mr:2,marginTop:"0px",color:"#fff",height:40,width:110}}>Copy URL</Button>
           <Popover  id={id} open={openPopover} anchorEl={anchorEl} onClose={handleClosePopover} anchorOrigin={{vertical: 'top',horizontal: 'center'}}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
      >
        <Typography sx={{ p: 2 }}>URL copied to clipboard.</Typography>
      </Popover>

      <Divider sx={{borderBottomWidth:1,borderColor:"#888",mb:1,mt:1}}></Divider>
        </Box>            
                         
       ))}
    </Box>:
    <Typography sx={{mt:4,fontSize:16}}>There is no bookmark present.</Typography>
    }
    
   </Box>
   :
      <div  style={{textAlign:"center", width:"100%"}}><CircularProgress sx={{marginTop:"10%"}}/>
      </div>} 

    <AppErrorPopup
      open={open}
      message={msg}
      severity={severity}
      onClose={handleClose}
      showCloseX
    />
    {/* Legacy snackbar (replaced by AppErrorPopup)
    <Snackbar onClose={handleClose} anchorOrigin={{vertical: 'top',horizontal: 'center'}}  open={open} autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION_SHORT} >
          <Alert  severity={severity} sx={{marginTop:"48px", width:{mobile: '80%',tablet:"70%",laptop:"40%" }}}>
            {msg}
          </Alert>  
       </Snackbar>
    */}
       {showLoginPopup?
         <LoginModal variant="sessionExpired" open onClose={()=>setShowLoginPopup(false)} msg={loginMsg}></LoginModal>  :
         <></>}   
   </>
  )
}

export default Bookmarks
